<app-header></app-header>
<div class="tracker-detail pt0">
    <app-step-progress-bar [wizardSteps]="steps" [stepName]="activeStepName" [stepCompleted]="activeStepCompleted">
    </app-step-progress-bar>
    <div class="container">
        <div class="mb-0 mb-md-5">
            <div class="row">
                <div class="col-sm-12">
                    <div class="innercard">
                        <h3 class="font24 clrblue mb20 center" translate>lblYourDetails</h3>
                        <div class="form-group">
                            <label class="mb5 labelcss" translate>lblPleaseCheckDetails</label>
                        </div>
                        <div class="form-group" *ngIf="!isPlanningAvailable" style="text-align: center;">
                            <span class="mb5 labelcss" style="color:red">
                                <label>{{getCheckInNotAllowed()}}</label>
                                <br>
                                <label translate>lblRefreshCheckIn</label>
                            </span>
                        </div>
                        <form [formGroup]="ownerVerificationdetails" class="form">
                            <div class="cmnform">
                                <div class="form-group">
                                    <label class="mb5" translate>lblName</label><span class="text-danger"> * </span>
                                    <input type="text" disabled formControlName="name" class="form-control" />
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 form-group">
                                        <div class="lbl-info">
                                            <label class="mb5" translate>lblAddress1</label><span class="text-danger"> *
                                            </span>
                                            <input type="text" [disabled]="isOwner" formControlName="address1"
                                                class="form-control" />
                                            <div *ngIf="(f.address1.touched || f.address1.dirty) && f.address1.errors">
                                                <div *ngIf="f.address1.errors.required"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblAddress1Required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 form-group">
                                        <div class="lbl-info">
                                            <label class="mb5" translate>lblPostcode</label><span class="text-danger"> *
                                            </span>
                                            <input type="text" [disabled]="isOwner" class="form-control"
                                                formControlName="postcode" />
                                            <div *ngIf="(f.postcode.touched || f.postcode.dirty) && f.postcode.errors">
                                                <div *ngIf="f.postcode.errors.required"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblPostCodeRequired
                                                </div>
                                                <div *ngIf="f.postcode.errors.pattern"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblValidPostcode
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="lbl-info form-group">
                                            <label translate>lblCity</label><span class="text-danger"> * </span>
                                            <input type="text" [disabled]="isOwner" formControlName="city"
                                                class="form-control" />
                                            <div *ngIf="(f.city.touched || f.city.dirty) && f.city.errors">
                                                <div *ngIf="f.city.errors.required" class="help-block mt-1 text-danger"
                                                    translate>
                                                    lblCityRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label for="email" translate>lblEmail</label><span class="text-danger"> *
                                            </span>
                                            <div class="lbl-info">
                                                <input formControlName="email" id="email" name="email"
                                                    [disabled]="isOwner" type="text" class="form-control" />
                                                <div *ngIf="(f.email.touched || f.email.dirty) && f.email.errors">
                                                    <div *ngIf="f.email.errors.required"
                                                        class="help-block mt-1 text-danger" translate>
                                                        lblEmailRequired
                                                    </div>
                                                    <div *ngIf="f.email.errors.pattern"
                                                        class="help-block mt-1 text-danger" translate>
                                                        lblEnterValidEmail
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 form-group">
                                        <div class="form-group">
                                            <label class="mb5" translate>lblPhoneNumber</label><span
                                                class="text-danger"> * </span>
                                            <div class="input-group mb-2">
                                                <ngx-intl-tel-input [selectFirstCountry]="false" (keypress)="isNumber($event)"
                                                    disabled
                                                    formControlName="phoneNumber" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
                                                    [phoneValidation]="false" [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                                                    class="w-100">
                                                </ngx-intl-tel-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottomaction">
        <div class="container">
            <div class="row">
                <div class="col-auto ml-auto">
                    <button type="submit" aria-label="Center Align" class="btn btn-primary btn-lg minwidth"
                        [disabled]="ownerVerificationdetails.invalid || !isPlanningAvailable"
                        (click)="ownerVerificationFormSubmit()">
                        <span translate>lblNext</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>